import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class AppRoutingService {
    private history = [];

    constructor(
        private router: Router
    ) { }

    public loadRouting(): void {
        // @ts-ignore
        this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            const { urlAfterRedirects } = event;
            // @ts-ignore
            this.history = [...this.history, urlAfterRedirects];
        });
    }

    public getHistory(): string[] {
        return this.history;
    }

    public getPreviousUrl(): string {
        return this.history[this.history.length - 2] || '/';
    }

    public isRefresh(): boolean {
        return this.history.length === 0;
    }
}
